<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<script>

import Debouncer from "@shared/Debouncer";
import BaseVModelView from "@/core/components/BaseVModelView.vue";

export default {
	extends: BaseVModelView,
	name: "DebounceVModelView",
	props: {
		inputDebounceDelay: Number,
	},
	watch: {
		inputDebounceDelay: {
			immediate: true,
			handler(newValue){
				// console.log("inputDebounceDelay changed: ", newValue)
				if(newValue > 0 && !this.debouncer){
					this.debouncer = new Debouncer()
				}
				if(this.debouncer){
					this.debouncer.setup(this.notifyValueChangedInternal, newValue)
				}
			}

		}
	},
	data() {
		return {
			debouncer: null
		}
	},
	methods: {

		notifyValueChangedDebounced(){
			this.notifyValueChanged()
		},

		notifyValueChanged(){
			if(this.debouncer){
				this.debouncer.onChangeDebounced()
			} else {
				this.notifyValueChangedInternal()
			}
		},

		notifyValueChangedImmediate(){
			let data
			if(this.debouncer){
				data = this.debouncer.onChangeImmediate()
			} else {
				data = this.notifyValueChangedInternal()
			}
			this.$emit("changeImmediate", data)
		}


	},

	computed: {

	}

}
</script>

<style>

</style>
